import {
  IJobsAccountHome,
  JobsAccountRole,
} from '../services/serviceJobsAccount/interfaces';
import { book } from '../routers/books';

type AccountRoleData = Pick<
IJobsAccountHome,
'primaryRole' | 'hasApplications' | 'hasListings' | 'hasApplicantAccess'
>;

export const hasBothJobsAccountRoles = (
  data: AccountRoleData | undefined
): boolean => Boolean(
  data?.hasApplications && (data?.hasListings || data?.hasApplicantAccess)
);

export const getJobsAccountRole = (
  data: AccountRoleData | undefined,
  pathname: string
): JobsAccountRole => {
  if (!data) return 'jobSeeker';

  const requestedRole = pathname === book.jobsEmployer
    || pathname.startsWith(`${book.jobsEmployer}/`)
    ? 'employer'
    : pathname === book.jobsJobSeeker
      || pathname.startsWith(`${book.jobsJobSeeker}/`)
      ? 'jobSeeker'
      : null;
  if (requestedRole === 'employer' && (data.hasListings || data.hasApplicantAccess)) return 'employer';
  if (requestedRole === 'jobSeeker' && data.hasApplications) return 'jobSeeker';

  return data.primaryRole;
};

export const getJobsAccountRolePath = (
  role: JobsAccountRole
): string => (
  role === 'employer' ? book.jobsEmployer : book.jobsJobSeeker
);
